module.exports = __webpack_public_path__ + "static/media/feature3.03da9c57.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/Home/feature3.svg
 ** module id = 631
 ** module chunks = 0
 **/